// import userData from "./data/data.json";
// const {user} = userData;
// console.log(user);
// const {products} = userData;
// console.log(products);
var $7e152637e430236b$exports = {};
$7e152637e430236b$exports = JSON.parse("{\"products\":[{\"name\":\"Laptop\",\"price\":200,\"description\":\"A high-performance laptop for all your needs.\",\"preview\":\"https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.brilliantnews.com%2Fwp-content%2Fuploads%2F2016%2F02%2Flaptop.jpg&f=1&nofb=1&ipt=2685354bff70101604ab17b6b79e6cb9314ce3315e8aeb2b55008e16c4bbd53d\"},{\"name\":\"Smartphone\",\"price\":300,\"description\":\"A modern smartphone with an excellent camera.\",\"preview\":\"https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fpngimg.com%2Fuploads%2Fsmartphone%2Fsmartphone_PNG8528.png&f=1&nofb=1&ipt=1e7156d217e86224608d52ec7eeea57488f5ebb393567361fae2db4697c8fa8c\"},{\"name\":\"Headphones\",\"price\":400,\"description\":\"Noise-cancelling headphones for better focus.\",\"preview\":\"https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fpngimg.com%2Fuploads%2Fheadphones%2Fheadphones_PNG101955.png&f=1&nofb=1&ipt=cb396566aa48dd0711e62d8764c01975a91e3196f0c41911107afcc956d46411\"}],\"favoriteProducts\":[{\"name\":\"Smartphone\",\"price\":300,\"description\":\"A modern smartphone with an excellent camera.\",\"preview\":\"https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fpngimg.com%2Fuploads%2Fsmartphone%2Fsmartphone_PNG8528.png&f=1&nofb=1&ipt=1e7156d217e86224608d52ec7eeea57488f5ebb393567361fae2db4697c8fa8c\"}],\"user\":{\"avatar\":\"https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fpngimg.com%2Fuploads%2Fsmartphone%2Fsmartphone_PNG8528.png&f=1&nofb=1&ipt=1e7156d217e86224608d52ec7eeea57488f5ebb393567361fae2db4697c8fa8c\",\"login\":\"login123\",\"password\":\"password123\"}}");


console.log((0, $7e152637e430236b$exports.user));
console.log((0, $7e152637e430236b$exports.products));
console.log((0, $7e152637e430236b$exports.favoriteProducts));


// метод stringify запаковує дані у рядок
const $cf7f018dc072a42f$var$age = 18;
const $cf7f018dc072a42f$var$films = [
    "Terrifier 1",
    "Terrifier 2",
    "Terrifier 3",
    "Saw 1",
    "Saw 2",
    "Saw 3",
    "Saw 4",
    "Saw 5",
    "Saw 6",
    "Saw 7",
    "Saw 8",
    "Saw 9",
    "Saw 10"
];
const $cf7f018dc072a42f$var$archivedAge = JSON.stringify($cf7f018dc072a42f$var$age);
console.log($cf7f018dc072a42f$var$archivedAge, typeof $cf7f018dc072a42f$var$archivedAge);
const $cf7f018dc072a42f$var$archivedFilms = JSON.stringify($cf7f018dc072a42f$var$films);
console.log($cf7f018dc072a42f$var$archivedFilms, typeof $cf7f018dc072a42f$var$archivedFilms);
// метод parse розпаковує дані з рядка
const $cf7f018dc072a42f$var$parsedAge = JSON.parse($cf7f018dc072a42f$var$age);
console.log($cf7f018dc072a42f$var$parsedAge, typeof $cf7f018dc072a42f$var$parsedAge);
const $cf7f018dc072a42f$var$parsedFilms = JSON.parse($cf7f018dc072a42f$var$films);
console.log($cf7f018dc072a42f$var$parsedFilms, typeof $cf7f018dc072a42f$var$parsedFilms);




//# sourceMappingURL=json-learn.10ac9e4b.js.map
